import * as Validation from "../../../common/utils/Validation";
import {checkUpdateTimeActionTypes} from "../constants/UtilityMiddlewareConstants";
import {addEditCountryActionTypes} from "../../../veritas/add-edit/constants/AddEditActionConstants";
import {apiActionsCountries} from "../constants/ApiMiddlewareConstants";


/**
 * This is the Middleware to validate the object generated by the add/edit Country modal.
 * @param store, action
 * @returns Makes the call to custom validation procedure and conditionally dispatches
 * the check-update action or the post action
 */

const validateCountryFormMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case addEditCountryActionTypes.VALIDATE_COUNTRY_FORM: {
            next(action);

            const { countryObj, notesObj, authToken } = action.payload;

            if(Validation.validateCountryForm(countryObj)) {
                // Add notesObj into countryObj, split into seperate obj and deleted on api
                countryObj.notes = notesObj;
                if (countryObj.id) {
                    // put, check update time
                    const countryID = countryObj.id;
                    store.dispatch({
                        type: checkUpdateTimeActionTypes.COUNTRY,
                        payload: {countryID, countryObj, authToken},
                    })
                } else {
                    // post
                    store.dispatch({
                        type: apiActionsCountries.POST,
                        payload: {countryObj, authToken},
                    })
                }
            }
            break;

        }

        default: next(action);
    }
}

export default validateCountryFormMiddleware;
